import React from "react";
import { useState } from "react";
import { ShowAll } from "../../../../index";
import { startRatingImage } from "../../../../../assets";
import {
  AwaitingPayment,
  AwaitingResponse,
  PaidAndWaiting,
  PendingAcceptance,
} from "./components";
import { Link, withRouter } from "react-router-dom";
import { Rating } from "@material-ui/lab";
import { useSockets } from "../../../../../Context/Context-Sockets/ContextSockets";

function RequestActions(props) {
  const { OpenChatFromRequest } = useSockets();

  const { request, fetchActiveRequests } = props;
  const {
    request_timeline_status,
    final_amount,
    final_comment,
    id,
    discount,
    request_type,
  } = request.request;
  const { request_bid, company_profile } = request;

  const [selectedRequest, setSelectedRequest] = useState("");
  const [popUpFlag, setPopUpFlag] = useState(false);

  const handleOpenChat = () => {
    console.log(request, "REQUEST");

    if (request_timeline_status !== 5) {
      OpenChatFromRequest(request.company_chat_obj);
      props.history.push("/dashboard/chats");
    } else {
      OpenChatFromRequest(request.foreman_chat_obj);
      props.history.push("/dashboard/chats");
    }
  };

  console.log(props, "props company");
  const Company_info = (
    <div className="request-detail-price-wrapper pt-3">
      <div className="row">
        <div className="col-12 col-sm-6 col-md-5 col-lg-4">
          <span className="small-font-size dark-grey-color overline">
            Company Name:
          </span>
          <span className="font-weight-bold pl-3">
            {company_profile && company_profile.name}{" "}
          </span>
        </div>
        {!request_type && (
          <div className="col-12 col-sm-6 col-md-5 col-lg-4">
            <span className="small-font-size dark-grey-color overline">
              Final price:
            </span>
            <span className="font-weight-bold pl-3">${final_amount}</span>
          </div>
        )}
        {parseInt(discount) > 0 && (
          <>
            {/*  */}
            {/* <div className="col-12 col-sm-6 col-md-5 col-lg-4 ">
              <span className="small-font-size dark-grey-color overline">
                Discount:
              </span>
              <span className="font-weight-bold pl-3">{discount}%</span>
            </div> */}
            {/*  */}
            <div className="col-12 col-sm-6 col-md-5 col-lg-4 pt-2 pb-1">
              <span className="small-font-size dark-grey-color overline">
                Discounted price:
              </span>
              <span className="font-weight-bold pl-3">
                ${final_amount * (1 - parseInt(discount) / 100)}
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );

  const Comment = final_comment && (
    <div className="request-comment-wrapper pt-3">
      <span className="small-font-size dark-grey-color overline mb-2">
        Comment:
      </span>{" "}
      <span className="small-font-size black-color">{final_comment}</span>
    </div>
  );
  {
    /* Awaiting Company Response for 0  */
  }
  if (request_timeline_status === 0) {
    return <AwaitingResponse />;
  }

  // if (request_timeline_status === 1) {
  //   return (
  //     <PendingAcceptance
  //       requestData={request}
  //       fetchActiveRequests={fetchActiveRequests}
  //     />
  //   );
  // }
  if (request_timeline_status === 2) {
    return <AwaitingPayment requestData={request} />;
  }

  // {/* Paid and waiting for move for 3 */}
  if (request_timeline_status === 3) {
    return (
      <PaidAndWaiting requestData={request} handleOpenChat={handleOpenChat} />
    );
  }

  return (
    <>
      {/* Truck assigned and ready to move for 4 */}
      {request_timeline_status === 4 && (
        <>
          {Company_info}
          {Comment}
          <div className="bid-status-wrapper pt-3">
            <div className="row justify-content-center">
              <div className="col-6 col-sm-3 col-md-2 text-center">
                <button
                  className="custom-buton custom-buton-large w-100"
                  onClick={handleOpenChat}
                >
                  Chat
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Move in progress for 5*/}
      {request_timeline_status === 5 && (
        <>
          {Company_info}
          {Comment}
          <div className="bid-status-wrapper pt-3">
            <div className="row justify-content-center">
              <div className="col-6 col-sm-3 col-md-2 text-center">
                <button
                  className="custom-buton custom-buton-large w-100"
                  onClick={() =>
                    props.history.push(
                      "/dashboard/my-requests/tracking-location/" + id
                    )
                  }
                >
                  Track
                </button>
              </div>
              <div className="col-6 col-sm-3 col-md-2 text-center">
                <button
                  className="custom-buton custom-buton-large w-100 custom-button-pink"
                  onClick={handleOpenChat}
                >
                  Chat
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Completed, waiting for confirmation for 6 */}
      {request_timeline_status === 6 && (
        <>
          {Company_info}
          {Comment}

          <div className="row justify-content-center">
            <div className="col-12 col-sm-6 col-md-5 col-lg-4 text-center pt-4">
              <button
                className="custom-buton custom-buton-large w-100"
                onClick={() =>
                  props.history.push(
                    "/dashboard/my-requests/confirm-complete/" + id
                  )
                }
              >
                Confirm move and release money
              </button>
            </div>
          </div>
        </>
      )}
      {/* Completed for 7 */}
      {request_timeline_status === 7 && (
        <>
          {Company_info}
          {Comment}

          <div className="row justify-content-center">
            <div className="col-12 col-sm-6 col-md-5 col-lg-4 text-center">
              <button
                className="custom-buton custom-buton-large w-100"
                onClick={() =>
                  props.history.push(`/dashboard/my-requests/${id}`)
                }
              >
                Leave feedback
              </button>
            </div>
          </div>
        </>
      )}
      {request_timeline_status === 8 && (
        <>
          {Company_info}
          <div className="row">
            <div className="col-12 col-sm-6 col-md-5 col-lg-4">
              <span className="small-font-size dark-grey-color overline">
                Tip:
              </span>
              <span className="font-weight-bold pl-3">$35</span>
            </div>
            <div className="col-12 col-sm-6 col-md-5 col-lg-4">
              <span className="small-font-size dark-grey-color overline">
                Rating:
              </span>
              <Rating
                style={{ verticalAlign: "bottom" }}
                className="pl-3"
                name="read-only"
                precision={0.1}
                value={request.get_feedback.company_rating}
                size="large"
                readOnly
              />
            </div>
          </div>
          <div className="request-comment-wrapper pt-3 pt-sm-3">
            <p className="small-font-size dark-grey-color overline mb-2">
              Feedback
            </p>
            <p className="small-font-size black-color">
              {request.get_feedback.company_comment}
            </p>
          </div>
        </>
      )}
    </>
  );
}

export default withRouter(RequestActions);
